import { render, staticRenderFns } from "./SlotTagChips.vue?vue&type=template&id=d5bbfe62&scoped=true&"
import script from "./SlotTagChips.vue?vue&type=script&lang=ts&"
export * from "./SlotTagChips.vue?vue&type=script&lang=ts&"
import style0 from "./SlotTagChips.vue?vue&type=style&index=0&id=d5bbfe62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5bbfe62",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
